var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgO2Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 499.99997,
    height: 480.40421,
    id: "svg2383",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2385"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0576499,0,0,1.0576499,-208.39268,-69.750455)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1858,0,0,1.1858,4.61306,-328.857)",
    id: "g2476"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5356,3.53494)",
    id: "g1988"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 158.73514,490.74919 c 0,88.22743 64.05154,161.33975 157.08081,161.33975 92.52812,0 156.57966,-73.11232 156.57966,-161.33975 0,-93.65548 -62.88243,-161.33968 -156.57966,-161.33968 -94.19838,0 -157.08081,67.6842 -157.08081,161.33968 m 60.4607,0 c 0,-58.61507 35.6584,-115.40963 96.62011,-115.40963 60.46063,0 96.11903,56.79456 96.11903,115.40963 0,54.99083 -29.56225,115.41805 -96.11903,115.41805 -67.05793,0 -96.62011,-60.42722 -96.62011,-115.41805",
    id: "path26",
    style: {
      fill: "#04256c",
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 557.40794,712.45771 v -21.51198 h -55.70062 c 22.29692,-21.89612 51.35816,-48.48539 51.35816,-77.42136 0,-26.7897 -16.78536,-39.88394 -42.7567,-39.88394 -13.86255,0 -28.1426,3.5241 -40.50199,9.77892 l 2.17126,22.68108 c 8.93551,-5.87073 19.9587,-10.95638 31.48297,-10.95638 11.1067,0 22.29692,5.87067 22.29692,18.38032 0,25.02771 -46.34754,63.74254 -59.04098,76.06018 v 22.87316 h 90.69098",
    id: "path28",
    style: {
      fill: "#04256c",
      fillRule: "nonzero",
      stroke: "none"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO2Logo);
export default __webpack_public_path__ + "static/media/o2-logo.376360facb458c261d7da4ce477add59.svg";
export { ForwardRef as ReactComponent };